import { useMediaQuery } from '@material-ui/core';
import React, { useEffect, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import ProgressBackdrop from '../../preorder/components/ProgressBackdrop';
import { useActivityContext } from '../contexts/useActivityContext';
import MgmActivity from './MgmActivity';

const ComponentMap = {
  MGM: MgmActivity,
};

export default () => {
  const isSM = useMediaQuery((theme) => theme.breakpoints.up('sm'));
  const { activityUrl: paramActivityUrl } = useParams();
  const { isLoading, loadActivities, activities } = useActivityContext();

  useEffect(() => {
    loadActivities();
  }, [loadActivities]);

  const activity = useMemo(() => activities.find((ac) => {
    const { activityUrl } = ac;
    return activityUrl === paramActivityUrl;
  }), [paramActivityUrl, activities]);

  const {
    template, templateData: data, backgroundUrlPc, backgroundUrlMobile,
  } = activity || {};

  if (isLoading) return <ProgressBackdrop isShow />;

  const CmpToRender = ComponentMap[(template || '')];

  if (!CmpToRender) return <ProgressBackdrop isShow />;

  return (
    <CmpToRender data={{
      ...data,
      backgroundUrl: isSM ? backgroundUrlPc : backgroundUrlMobile,
    }}
    />
  );
};
